export enum EJabatanType {
  KEPALA = 'kepala',
  FUNGSIONAL = 'fungsional',
  CUSTOM = 'custom'
}
export enum EUnitKerjaType {
  SIMPEG = 1,
  CUSTOM = 2
}
export enum EGender {
  MALE = 'M',
  FEMALE = 'F'
}
export enum ELmsRole {
  TEACHER = 'teacher',
  STUDENT = 'user',
  ADMIN = 'admin'
}
